export { default as PrivacyPage } from "./privacy";
